import { apiRequest } from './client';
import type { IrrigationHistory, IrrigationRepository, IrrigationScheduleInput } from '../../application/ports/IrrigationRepository';
import type { IrrigationEvent, IrrigationSchedule } from '../../domain/Irrigation';

const base = (deviceId: string, channel: number) => `/devices/${deviceId}/valves/${channel}/irrigation`;

export class HttpIrrigationRepository implements IrrigationRepository {
  getStatus(deviceId: string, channel: number) {
    return apiRequest<{ running: IrrigationEvent | null }>(`${base(deviceId, channel)}/status`);
  }

  open(deviceId: string, channel: number) {
    return apiRequest<{ event: IrrigationEvent }>(`${base(deviceId, channel)}/open`, { method: 'POST' });
  }

  close(deviceId: string, channel: number) {
    return apiRequest<{ event: IrrigationEvent }>(`${base(deviceId, channel)}/close`, { method: 'POST' });
  }

  getSchedule(deviceId: string, channel: number) {
    return apiRequest<{ schedule: IrrigationSchedule | null }>(`${base(deviceId, channel)}/schedule`);
  }

  saveSchedule(deviceId: string, channel: number, input: IrrigationScheduleInput) {
    return apiRequest<{ schedule: IrrigationSchedule }>(`${base(deviceId, channel)}/schedule`, {
      method: 'PUT',
      body: JSON.stringify(input),
    });
  }

  deleteSchedule(deviceId: string, channel: number) {
    return apiRequest<void>(`${base(deviceId, channel)}/schedule`, { method: 'DELETE' });
  }

  getHistory(deviceId: string, channel: number) {
    return apiRequest<IrrigationHistory>(`${base(deviceId, channel)}/history`);
  }

  getStationHistory(deviceId: string) {
    return apiRequest<IrrigationHistory>(`/devices/${deviceId}/irrigation-history`);
  }
}
